<template>
    <div>
        <div class="leaderBox" v-if="showOrhide1">
            <div class="newtext">新手指引</div>
            <img src="../../../assets/images/maskClose.png" class="closeIt" @click="closeIt1">
            <img src="../../../assets/images/xqgl1.png" class="steps step4" v-if="status1==1">
            <img src="../../../assets/images/xqgl2.png" class="steps step5" v-if="status1==2">
            <img src="../../../assets/images/xqgl3.png" class="steps step6" v-if="status1==3">
            <img src="../../../assets/images/xqgl4.png" class="steps step7" v-if="status1==4">
            <div class="stepbtn" @click="nextStep1(status1)">
                {{status1==1?"下一步":status1==2?"下一步":status1==3?"下一步":status1==4?"我知道了":"我知道了"}}
            </div>
            <div class="bottomTip">
                <el-checkbox v-model="checked1">下次不再提示</el-checkbox>
            </div>
        </div>
        <breadcrumb :routerList="[{to:'/xuqiu/resourceList',title:'资源需求管理'},{title:'1+N体系'}]"/>
        <div style="margin:20px">
            <div class="h-piece">
                <div class="h-formBox">
                    <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
						<div class="h-thirdColumn">
							<el-form-item label="客户名称">
							    <el-input v-model="q.euNameLike" placeholder="请输入客户名称"></el-input>
							</el-form-item>
							<el-form-item label="链群">
							    <el-select v-model="q.jobGroup" :v="q.jobGroup"
							               placeholder="请选择" :clearable="true"
							    @change="okJobPoint">
							        <el-option v-for="(item) in JobGroup"
							                   :key="item.id"
							                   :label="item.jobGroup"
							                   :value="item.jobGroup"
							        >
							        </el-option>
							    </el-select>
							</el-form-item>
							<el-form-item label="节点">
							    <el-select v-model="q.jobPoint" :v="q.jobPoint"
							               placeholder="请选择" :clearable="true" :disabled="canjobpoint">
							        <el-option v-for="(item,index) in JobPoint"
							                   :key="index"
							                   :label="item"
							                   :value="item"
							        >
							        </el-option>
							    </el-select>
							</el-form-item>
							
						</div>	
                        <div class="h-thirdColumn">
                        	<el-form-item label="创建时间" class="timeselect">
								<el-date-picker style="width: 1.5rem;"
									placeholder="请选择"
									v-model="q.startCdate"
									clearable
									type="date"
									value-format="yyyy-MM-dd" >
								</el-date-picker>
								至
								<el-date-picker style="width:1.5rem;"
									placeholder="请选择"
									v-model="q.endCdate"
									clearable
									type="date"
									value-format="yyyy-MM-dd" >
								</el-date-picker>
                        	</el-form-item>
							<el-form-item label="区域">
							    <brselect category="YLRegion" :v="q.areaCode" v-model="q.areaCode" :clearable="true"
							              style="width:100%"/>
							</el-form-item>
                        </div>	
                        
                        <div class="h-formBtnOut h-columnCenter">
                            <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
                            <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置
                            </el-button>
							<el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus"
							           v-auth="'xuqiu_xinzengzyxuqiu'"
							           @click="createdemand">新增需求
							</el-button>
                        </div>
                    </el-form>
                </div>
            </div>
            <div class="h-row">
                <div class="h-rowIn" style="width: 57%;">
                    <div style="height: 9.3rem;overflow: hidden;background-color: white;position: relative;">
                        <div class="h-rowBox" style="border-bottom: none;box-shadow: none;">
                            <div class="h-rowTitle h-pdl0">
                                <div class="h-el-tab">
                                    <ul>
                                        <li :class="{'h-active':index==indx}" v-for="(item,index) in list" :key="index"
                                            @click="tabIndex(index)"><a>{{item}}</a></li>
                                    </ul>
                                </div>
                            </div>
                            <el-table
                                    class="ljjtablesdata"
                                    :span-method="objectSpanMethod"
                                    :data="tableData"
                                    style="width: 100%">
                                <el-table-column
                                        prop="cuname"
                                        label="提报人"
                                        :show-overflow-tooltip="true"
                                        >
                                </el-table-column>
                                <el-table-column
                                        prop="jobGroup"
                                        label="链群"
                                        :show-overflow-tooltip="true"
                                        >
                                </el-table-column>
                                <el-table-column
                                        prop="jobGroupPoint"
                                        label="资源分类"
                                        >
                                </el-table-column>
                                <el-table-column
                                        label="状态"
                                        >
                                    <template slot-scope="scope">
                                        <div style="display: flex;justify-content: center;">
											<div class="bihuans" v-if="scope.row.isLoop == 1" style="color: #2eaf68;border-radius: 0.2rem;padding: 0.05rem;border: 1px solid #2eaf68;">
											    已闭环
											</div>
											<div class="bihuans" v-if="scope.row.isLoop ==0 && scope.row.inNumber==0 && scope.row.isOverdue ==0 && scope.row.isTrip==0" style="color: #258efe;border-radius: 0.2rem;padding: 0.05rem;border: 1px solid #258efe;">
											    未回复
											</div>
											<div class="bihuans" v-if="scope.row.isLoop ==0 && scope.row.inNumber==1" style="color: #BF3EFF;border-radius: 0.2rem;padding: 0.05rem;border: 1px solid #BF3EFF;">
											    未闭环
											</div>
											
											<div class="bihuans" v-if="scope.row.isLoop ==0 && scope.row.inNumber==0 && scope.row.isOverdue ==1 && scope.row.isTrip==0" style="color: #f2bd2e;border-radius: 0.2rem;padding: 0.05rem;border: 1px solid #f2bd2e;">
											    逾期
											</div>
											<div class="bihuans" v-if="scope.row.isLoop ==0 && scope.row.inNumber==0 && scope.row.isOverdue ==1 && scope.row.isTrip==1" style="color: #FF0000;border-radius: 0.2rem;padding: 0.05rem;border: 1px solid #FF0000;">
											    跳闸
											</div>
										</div>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <div class="fenyes" style="margin-top: 0.3rem">
                                <pagination :page="q" @query="query" style="padding-top: 0.1rem"/>
                            </div>
                            <div v-if="tableData.length<5"
                                 style="display:flex;justify-content:center;padding-top: 30px;align-items: center;">
                                <img src="../../../assets/images/mylittle.png" alt="" style="width: 75%;">
                            </div>
                            <div class="h-rowBoxB h-rowBoxBtnOut"
                                 style="margin: 0;padding: 0.11rem 0.26rem;display: flex;align-items: center;height: 67px;position: absolute;bottom: 0;left: 0;width: 100%;border: 1px solid #d7e0f1;">
                                <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                                           @click="exportExcel" v-auth="'xuqiu_zypiliangdaochu'">批量导出
                                </el-button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="h-rowIn" style="width: 43%;">
                    <div style="height: 9.3rem;overflow-y: auto;background-color: white;padding: 0;position: relative;">
                        <div class="h-rowBox">
                            <div class="h-rowTitle">
                                <div class="h-disTable">
                                    <div class="h-tableCell">
                                        <h1>集思广益</h1>
                                    </div>
                                </div>
                            </div>
                            <div class="h-rowCon" style="padding-bottom: 0">
                               <div class="maincommentboxs">
								   <img src="../../../assets/images/resourseevaimg/evabj.png" alt="" class="maincommentimg">
								   <div class="maincommenttextbox maincommentposition">
									   <div class="maincommenttextleft">
										   <div class="maincommenttextlefttexts">肖静</div>
										   <div class="maincommenttextleftconts">区域经理</div>
									   </div>
									   <div class="maincommenttextright">
										   <img src="../../../assets/images/resourseevaimg/evatime.png" alt="">
										   <p class="maincommenttextrighttime">2020年1月15日 18：33：12</p>
									   </div>
								   </div>
									<div class="maincommenttitle maincommentposition">
										医疗设备是医院建设的重要物质条件也是医疗设备水平是医院
									</div>
									<div v-if="msgs.length>101" class="maincommentcontentbox maincommentposition overflow3">
										{{msgs.substring(0,102)}}...
										<span class="maincommentcontentboxbtns" @click="morecomment">查看更多</span>
									</div>
									<div v-else class="maincommentcontentbox maincommentposition overflow3">
										{{msgs}}
									</div>
									<div class="maincommentbottombox maincommentposition">
										<div class="maincommentbottomleftbox">
											<img src="../../../assets/images/resourseevaimg/evaaddress.png" alt="">
											<div class="maincommentbottomleftboxtexts">北京</div>
										</div>
										<div class="maincommentbottomrightbox">
											<div class="maincommentbottomrightcontent">
												<img src="../../../assets/images/resourseevaimg/evadown.png" alt="" style="cursor: pointer;">
												<div class="maincommentbottomrightcontenttext" style="cursor: pointer;">下载</div>
											</div>
											<div class="maincommentbottomrightcontent">
												<img src="../../../assets/images/resourseevaimg/zanH.png" alt="" style="cursor: pointer;">
												<!-- <img src="../../../assets/images/resourseevaimg/zanS.png" alt="" style="cursor: pointer;"> -->
												<div class="maincommentbottomrightcontenttext">1</div>
											</div>
											<div class="maincommentbottomrightcontent">
												<img src="../../../assets/images/resourseevaimg/caiH.png" alt="" style="cursor: pointer;">
												<!-- <img src="../../../assets/images/resourseevaimg/caiS.png" alt="" style="cursor: pointer;"> -->
												<div class="maincommentbottomrightcontenttext">2</div>
											</div>
										</div>
									</div>
								</div>
								
								<div class="h-rowTitle">
								    <div class="h-disTable">
								        <div class="h-tableCell">
								            <h1>全部评论</h1>
								        </div>
								    </div>
								</div>
								
								<div class="replaybox">
									<div class="replayboxlists">
										<div class="replaylist">
											<div class="maincommenttextbox maincommentposition">
											   <div class="maincommenttextleft">
												   <div class="maincommenttextlefttexts">肖静</div>
												   <div class="maincommenttextleftconts">区域经理</div>
											   </div>
											   <div class="maincommenttextright">
												   <img src="../../../assets/images/resourseevaimg/evatime.png" alt="">
												   <p class="maincommenttextrighttime">2020年1月15日 18：33：12</p>
											   </div>
											</div>
											<div class="maincommentcontentbox maincommentposition" style="margin-top: 0.2rem;">
												{{msgs}}
											</div>
											<div class="maincommentbottombox maincommentposition">
												<div class="maincommentbottomleftbox">
													<img src="../../../assets/images/resourseevaimg/evaaddress.png" alt="">
													<div class="maincommentbottomleftboxtexts">北京</div>
												</div>
												<div class="maincommentbottomrightbox">
													<div class="maincommentbottomrightcontent">
														<img src="../../../assets/images/resourseevaimg/evadown.png" alt="" style="cursor: pointer;">
														<div class="maincommentbottomrightcontenttext" style="cursor: pointer;">下载</div>
													</div>
													<div class="maincommentbottomrightcontent">
														<img src="../../../assets/images/resourseevaimg/zanH.png" alt="" style="cursor: pointer;">
														<!-- <img src="../../../assets/images/resourseevaimg/zanS.png" alt="" style="cursor: pointer;"> -->
														<div class="maincommentbottomrightcontenttext">1</div>
													</div>
													<div class="maincommentbottomrightcontent">
														<img src="../../../assets/images/resourseevaimg/caiH.png" alt="" style="cursor: pointer;">
														<!-- <img src="../../../assets/images/resourseevaimg/caiS.png" alt="" style="cursor: pointer;"> -->
														<div class="maincommentbottomrightcontenttext">2</div>
													</div>
												</div>
											</div>
										</div>
										
									</div>
									<div class="lookmore">查看更多</div>
								</div>
								
								<div class="textareabox">
									<el-input
										class="textareas"
									  type="textarea"
									  placeholder="请输入您的精彩评论"
									  v-model="textarea"
									  maxlength="500"
									  show-word-limit
									  resize="none"
									>
									</el-input>
									<div class="fasendBoxs">
										<div class="fasenduploadbox">
											<img src="../../../assets/images/resourseevaimg/evaupload.png" alt="">
											<div class="fasenduploadtexts">上传附件</div>
										</div>
										<div class="fasend">发表</div>
									</div>
								</div>
								
                            </div>
                        </div>
                        
                        
					</div>
				</div>
			</div>
            </div>
            <demandadd :visible.sync="imgflag2" v-if="imgflag2" @imgfalse2="imgflag2=false"/>
			<el-dialog :close-on-click-modal="false" :visible.sync="dialogFormVisible" class="h-dialog2" @close="cancelPro('f')">
			    <div class="h-dialogImg">
			        <div class="h-disTable">
			            <div class="h-tableCell">
			                <h1>1+N体系</h1>
			                <p>1+N System</p>
			            </div>
			        </div>
			    </div>
			    <div class="tanchaunbox">
					<div class="maincommenttextbox maincommentposition">
					   <div class="maincommenttextleft">
						   <div class="maincommenttextlefttexts">肖静</div>
						   <div class="maincommenttextleftconts">区域经理</div>
					   </div>
					   <div class="maincommenttextright">
						   <img src="../../../assets/images/resourseevaimg/evatime.png" alt="">
						   <p class="maincommenttextrighttime">2020年1月15日 18：33：12</p>
					   </div>
					</div>
					<div class="maincommenttitle maincommentposition" style="margin: 0.2rem 0;">
						医疗设备是医院建设的重要物质条件也是医疗设备水平是医院
					</div>
					<div class="maincommentcontentbox maincommentposition">
						{{msgs}}
					</div>
					<div class="maincommentbottombox maincommentposition" style="margin-top: 0.3rem;">
						<div class="maincommentbottomleftbox">
							<img src="../../../assets/images/resourseevaimg/evaaddress.png" alt="">
							<div class="maincommentbottomleftboxtexts">北京</div>
						</div>
						<div class="maincommentbottomrightbox">
							<div class="maincommentbottomrightcontent">
								<img src="../../../assets/images/resourseevaimg/evadown.png" alt="" style="cursor: pointer;">
								<div class="maincommentbottomrightcontenttext" style="cursor: pointer;">下载</div>
							</div>
							<div class="maincommentbottomrightcontent">
								<img src="../../../assets/images/resourseevaimg/zanH.png" alt="" style="cursor: pointer;">
								<!-- <img src="../../../assets/images/resourseevaimg/zanS.png" alt="" style="cursor: pointer;"> -->
								<div class="maincommentbottomrightcontenttext">1</div>
							</div>
							<div class="maincommentbottomrightcontent">
								<img src="../../../assets/images/resourseevaimg/caiH.png" alt="" style="cursor: pointer;">
								<!-- <img src="../../../assets/images/resourseevaimg/caiS.png" alt="" style="cursor: pointer;"> -->
								<div class="maincommentbottomrightcontenttext">2</div>
							</div>
						</div>
					</div>
				</div>
			</el-dialog>
        </div>
    </div>
</template>

<script>
    import ss from '../../../api/SystemService'
    import updownfile from '../../../utils/updownfile'
    import uploaddownexcel from '../../../components/uploaddown/uploaddownexcel'

    export default {
        components: {
            uploaddownexcel,
        },
        data() {
            return {
				dialogFormVisible:false,
                canjobpoint:true,
                //链群
                JobGroup: [],
                JobPoint:[],
                showOrhide1: false,
                status1: 1,
                checked1: true,
                toshow1: "Lmanagement3",
                imgflag2: false,
                timeValue: null,
                val: [],
                n: {},
                //切换
                indx: 0,
                list: ['全部', '进行中', '已过期'],
                q: {
                    startCdate: null,
                    endCdate: null,
                    euNameLike: null,
                    jobGroup:null,
                    jobPoint:null,
                    areaCode:null,
                    isLoop:null,
                    isTrip:null,
                    isOverdue:null,
                    inNumber:null,
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                },
				textarea:'',
                l:{
                    jobGroup:null,
                    pageSize: 6,
                    pageNo: 1,
                    total: 0,
                },
                tableData: [],
				msgs:'一二三四五六七八九十一二三四五六七八九十一二三四五六七八九十一二三四五六七八九十一二三四五六七八九十一六七一二三四五六七八九十一二三四五六七八九十一二三四五六七八九十一二三四五六七八九十一二三四五六七八九十一六七一二三四五六七八九十一二三四五六七八九十一二三四五六七八九十一二三四五六七八九十一二三四五六七八九十一六七'
            }
        },
        methods: {
			// 查看消息
			morecomment(){
				this.dialogFormVisible = true;
			},
			//全部/已转化/未转化标签
			tabIndex(i) {
			    this.indx = i;
			},
            getSpanArr() {
                this.spanArr = [];
                this.tableData.forEach((item, index) => {
                    if (index === 0) {
                        this.spanArr.push(1);
                        this.position = 0;
                    } else {
                        if (this.tableData[index].rdId === this.tableData[index - 1].rdId) {
                            this.spanArr[this.position] += 1;
                            this.spanArr.push(0);
                        } else {
                            this.spanArr.push(1);
                            this.position = index;
                        }
                    }
                })
            },
            objectSpanMethod({row, column, rowIndex, columnIndex}) {
                if (column.label == '提报人'){
                    const _row = this.spanArr[rowIndex];
                    const _col = _row > 0 ? 1 : 0;
                    return {
                        rowspan: _row,
                        colspan: _col
                    }
                }
            },
            //节点筛选可用
            okJobPoint(){
                if(this.q.jobGroup!=null){
                    this.canjobpoint = false;
                    ss.UserDemand.selectJobPoint(this.q.jobGroup).then(rd => {
                        this.JobPoint = rd;
                    });
                }else{
                    this.canjobpoint = true;
                    this.q.jobPoint = null;
                }
            },
            //部门列表
            selectJobGroup() {
                ss.UserDemand.selectJobGroup().then(rd => {
                    this.JobGroup = rd;
                });
            },
            showzhezhao() {
                ss.salesList.toshow(this.toshow1).then(rd => {
                    if (rd == false) {
                        this.showOrhide1 = false;
                    } else {
                        this.showOrhide1 = true;
                    }
                })
            },
            timeSelect() {
                if (this.timeValue == null || this.timeValue == '') {
                    this.q.startCdate = null;
                    this.q.endCdate = null;
                } else {
                    this.q.startCdate = this.timeValue[0];
                    this.q.endCdate = this.timeValue[1];
                }
            },
            //重置检索项
            resetData() {
				console.log(1)
				this.q.jobGroup = null;
				this.q.jobPoint = null;
                this.q.euNameLike = null;
                this.timeValue = null;
                this.q.startCdate = null;
                this.q.endCdate = null;
				this.q.areaCode = null;
				this.query()
            },
            //检索
            handleFilter(query) {
                this.query();
            },
            //表格
            query() {
                ss.UserDemand.showZYXQPage(this.q).then(rd => {
                    this.q.total = rd.total;
                    this.tableData = rd.records;
                    this.getSpanArr();
                });
            },
           
            //新增需求
            createdemand() {
                this.$router.push('/xuqiu/createResources');
            },
            xuqiuEdit(value) {
                this.$router.push({
                        path: "/xuqiu/createResources",
                        query: {id: value.id, demandType: value.demandType}
                });
            },
            //点击详情跳转
            xuqiuDetail(value) {
                this.$router.push({path: "/xuqiu/resources", query: {id: value.id}});
            },
            //明细导出
            exportExcel() {
                updownfile.down("/api/swyl/v1/xuqiu/userResDemandDept/downloadExcel", this.q, "post");
            },
            closeIt1() {
                this.showOrhide1 = false;
                if (this.checked1) {
                    ss.salesList.toshow(this.toshow1, this.checked1).then(rd => {
                        this.showOrhide1 = false;
                    })
                } else {
                    ss.salesList.toshow(this.toshow1, this.checked1).then(rd => {
                        this.showOrhide1 = false;
                    })
                }
            },

            nextStep1(i) {
                if (this.status1 == 1) {
                    this.status1 = 2;
                } else if (this.status1 == 2) {
                    this.status1 = 3;
                } else if (this.status1 == 3) {
                    this.status1 = 4;
                } else if (this.status1 == 4) {
                    if (this.checked1) {
                        ss.salesList.toshow(this.toshow1, this.checked1).then(rd => {
                            this.showOrhide1 = false;
                        })
                    } else {
                        ss.salesList.toshow(this.toshow1, this.checked1).then(rd => {
                            this.showOrhide1 = false;
                        })
                    }
                }

            },
        },
        created() {
            this.showzhezhao();
            this.selectJobGroup();
            this.query();
        },
        mounted() {
            this.query();
        },
    }
</script>

<style scoped>
	.overflow3{
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 3;
		overflow: hidden;
	}
    .cuname {
        font-size: 0.16rem;
        color: #323232;
    }
	.bihuans{
		width: 1rem;
	}
	.maincommentboxs{
		width: 100%;
		max-height: 2.71rem;
		/* height: 2.71rem; */
		background-color: #ffffff;
		box-shadow: 0px 0px 11px 2px 
			rgba(189, 195, 203, 0.46);
		position: relative;
		overflow: hidden;
		padding: 0.26rem;
	}
	.maincommentimg{
		position: absolute;
		top: 0;
		right: 0;
		z-index: 0;
	}
	.maincommentposition{
		position: relative;
		z-index: 1;
	}
	.maincommenttextbox{
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.maincommenttextleft{
		display: flex;
		align-items: center;
	}
	.maincommenttextlefttexts{
		font-size: 0.18rem;
		font-weight: bold;
		color: #282828;
	}
	.maincommenttextleftconts{
		padding: 0.05rem 0.1rem;
		background-color: #d1e4ff;
		border-radius: 0.15rem;
		font-size: 0.16rem;
		color: #006ccf;
		margin-left: 0.1rem;
	}
	.maincommenttextright{
		display: flex;
		align-items: center;
	}
	.maincommenttextright img{
		height: 0.2rem;
	}
	.maincommenttextrighttime{
		font-size: 0.14rem;
		margin-left: 0.1rem;
		color: #999999;
	}
	.maincommenttitle{
		font-size: 0.18rem;
		color: #333;
		font-weight: bold;
		margin: 0.1rem 0;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	.maincommentcontentbox{
		font-size: 0.16rem;
		color: #616467;
		
		line-height: 0.25rem;
	}
	.maincommentcontentboxbtns{
		width: 0.8rem;
		height: 0.26rem;
		background-color: #3e99f2;
		border-radius: 0.05rem;
		display: inline-block;
		text-align: center;
		line-height: 0.26rem;
		color: #ffffff;
		font-size: 0.14rem;
		cursor: pointer;
	}
	.maincommentbottombox{
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-top: 0.2rem;
	}
	.maincommentbottomleftbox{
		display: flex;
		align-items: center;
		font-size: 0.14rem;
		color: #999;
	}
	.maincommentbottomleftboxtexts{
		margin-left: 0.1rem;
	}
	.maincommentbottomrightcontent{
		margin-left: 0.3rem;
		display: flex;
		align-items: center;
	}
	.maincommentbottomrightbox{
		display: flex;
		align-items: center;
	}
	.maincommentbottomrightbox img{
		height: 0.21rem;
	}
	.maincommentbottomrightcontenttext{
		font-size: 0.16rem;
		color: #59b0ff;
		margin-left: 0.1rem;
		/* color: #666666; */
	}
	.replaybox{
		padding: 0.26rem;
		height: 3rem;
	}
	.replayboxlists{
		height: 2.3rem;
		overflow-y: auto;
	}
	.replayboxlists::-webkit-scrollbar {
		background: #3e99f2;
		border-radius: 0.1rem;
		padding: 0.2rem 0;
		width: 0.1rem;
	}
	.replaylist{
		border-bottom:1px solid #e1e1e1;
		padding-bottom: 0.2rem;
		margin-bottom: 0.3rem;
	}
	.lookmore{
		width: 0.8rem;
		height: 0.26rem;
		background-color: #3e99f2;
		border-radius: 0.05rem;
		margin: 0 auto;
		text-align: center;
		line-height: 0.26rem;
		color: #fff;
		cursor: pointer;
		margin-top: 0.25rem;
	}
	.textareas{
		margin-top: 0.3rem;
	}
	.fasendBoxs{
		margin-top: 0.2rem;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding-bottom: 0.35rem;
	}
	.fasenduploadbox{
		display: flex;
		align-items: center;
		color:#59b0ff;
		font-size: 0.16rem;
	}
	.fasenduploadbox img{
		height: 0.24rem;
		cursor: pointer;
	}
	.fasenduploadtexts{
		margin-left: 0.1rem;
		cursor: pointer;
	}
	.fasend{
		width: 0.99rem;
		height: 0.31rem;
		background-color: #59b0ff;
		border-radius: 0.04rem;
		text-align: center;
		line-height: 0.31rem;
		font-size: 0.18rem;
		color: #fff;
		cursor: pointer;
	}
	.tanchaunbox{
		padding: 0.5rem;
	}
</style>
<style>
	.textareas .el-textarea__inner{
		height: 1rem;
		min-height: 0;
	}
    .selectcheckbox .el-checkbox:hover {
        background: 0
    }

    .selectcheckbox .el-checkbox {
        margin-bottom: 5px
    }

    .selectcheckbox .el-checkbox__label {
        display: none
    }


    .el-form-item__content .secondX {
        position: absolute;
        top: 0;
        left: -89px;
        color: red;
        font-size: 0.2rem;
    }

    .fenyes .el-pagination .el-pagination__sizes {
        display: none;
    }

    .h-formBorder .timeselect .el-form-item__content {
        line-height: 0.2rem;
    }

    .h-formBorder .timeselect .el-date-editor .el-range-separator {
        width: 8%;
        line-height: 0.34rem;
    }

    .h-formBorder .timeselect .el-input__inner {
        padding-right: 0.1rem;
    }

    .timeselect .el-date-editor.el-input__inner {
        width: 3.5rem;
    }

    .ljjtablesdata.el-table tbody td:first-child{
        border-left: 0;
    }
    .ljjtablesdata.el-table tbody td:first-child{
        border-right: 1px solid #EBEEF5;
    }
    .ljjtablesdata.el-table tbody td{
        border-right: 0;
    }
    .ljjtablesdata.el-table thead{
        color: #323232;
    }
    .ljjtablesdata.el-table thead tr{
        background-color: rgba(0,0,0,0);
    }
    .ljjtablesdata.el-table thead th{
        background: none;
    }
    .ljjtablesdata.el-table .warning-row {
        background: #f5fcff;
    }
    .ljjtablesdata.el-table .zfenleis{
        padding: 0.05rem;
        background: #fce0b7;
        color: #d99a4b;
        margin-right: 0.05rem;
    }
    .ljjtablesdata.el-table .zfenleis:nth-child(2){
        background: #d1e4ff;
        color: #006ccf;
    }
</style>
<style scoped lang="scss">
    .bottomTip {
        position: absolute;
        left: 49.7%;
        bottom: 0.3rem;
        transform: translateX(-50%);
    }

    .newtext {
        font-size: 0.28rem;
        color: white;
        position: absolute;
        top: 0.2rem;
        left: 50%;
        transform: translateX(-50%);
        font-weight: bold;
        text-shadow: 1px 1px 4px #2785E7;
        z-index: 2;
    }

    .leaderBox {
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.4);
        position: fixed;
        z-index: 99999;
        overflow: hidden;
        top: 0;
        left: 0;

        .leaderbg {
            width: 100%;
            height: 100%;
        }

        .steps {
            position: absolute;
            z-index: 1;
        }

        .step4 {
            top: 0.8rem;
            left: 0rem;
            width: 6.6rem;
            height: 15rem;
        }

        .step5 {
            top: 2.2rem;
            right: 1.35rem;
            width: 4.7rem;
            height: 1rem;
        }

        .step6 {
            top: 2.28rem;
            left: 2.6rem;
            width: 9.2rem;
            height: 12rem;
        }

        .step7 {
            top: 3.45rem;
            right: 0.2rem;
            width: 6.9rem;
            height: 12rem;
        }

        .stepbtn {
            width: 1.9rem;
            height: 0.6rem;
            border: 0.03rem solid #FFFFFF;
            background-color: rgba(0, 0, 0, 0.1);
            border-radius: 5px;
            display: flex;
            justify-content: center;
            line-height: 0.5rem;
            position: absolute;
            z-index: 99;
            bottom: 0.75rem;
            left: 50%;
            transform: translateX(-50%);
            font-size: 0.27rem;
            letter-spacing: 2px;
            color: white;
            cursor: pointer;
        }

        .closeIt {
            width: 0.3rem;
            height: 0.3rem;
            position: absolute;
            top: 0.2rem;
            right: 0.2rem;
            cursor: pointer;
        }
    }
</style>
